import React from 'react';
import "./styles.css";

/**
 * @function VerificationProgressWidget
 * @param className - Allows us to pass a class name to the progress bar
 * @return {React.Component}
 * @exported true
 * @description The progress bar that shows on the VerificationPage
 */

export default function VerificationProgressWidget(props){
  const className = props.className;

  return(
    <div className="verification-progress-widget">
      <div className="progress-bar-container">
        <div className={className + " progress-bar"}></div>
      </div>
    </div>
  );
}